import { Button, styled } from '@mui/joy';

export const ButtonMain = styled(Button)`
  background-color: ${({ theme }) => theme.vars.palette.brown};
  color: ${({ theme }) => theme.palette.common.white};
  min-height: 48px;
  border-radius: 2px;
  width: '100%';
  text-align: center;
  font-size: ${({ theme }) => theme.typography['body-sm'].fontSize};
  font-weight: ${({ theme }) => theme.typography.h3};
  &:hover {
    background-color: ${({ theme }) => theme.vars.palette.hoverBrown};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.vars.palette.grey3};
  }
`;
